export class CrossSiteScripting {
    /**
     * @param html {String}
     */
    static sanitize(html) {
        return html.replace("<script>", "&lt;script&gt;")
            .replace("</script>", "&lt;/script&gt;")
            .replace("<style>", "&lt;style&gt;")
            .replace("</style>", "&lt;/style&gt;")
            .replace("javascript:", "")
    }
}
